import styled from 'styled-components';

export const StyledSimpleLineChart = styled.div`
	width: 100% !important;
	@media screen and (max-width: 1366px) {
		margin-bottom: 30px;
	}

	.recharts-wrapper .recharts-default-legend {
		text-align: left !important;
		position: relative !important;
		left: 122px !important;
		@media screen and (max-width: 1600px) {
			left: 20px;
		}
	}

	.recharts-wrapper, svg.recharts-surface {
		transform: translateX(-10px) !important;
		font-size: 14px;
		.recharts-tooltip-cursor {
			display: none !important;
		}
		@media screen and (max-width: 1366px) {
			display: flex;
			margin: 0 auto;
		}
	}

	.container-dates {
		width: 100%;
		display: flex;
		justify-content: space-between;
		max-width: 100%;
		margin: 5px auto 15px;
		padding: 0px 30px;
		font-size: 14px;
		color: #707070;
		font-weight: bold;
		@media screen and (min-width: 1370px) {
			max-width: 980px;
			transform: translateX(-25px);
		}
		@media screen and (max-width: 1135px) {
			transform: translateX(0);
			padding: 0 20px;
		}
	}

	@media print {

		.recharts-wrapper{
			width: 100% !important;
			transform: translateX(-10px) !important;
			font-size: 14px;
			display: flex;
			flex: 1;
			justify-content: space-between;
			margin: 0px !important;

			svg{
				width: 100% !important;
				visibility: visible !important;
				margin: 0 auto !important;
			}
		}

		.recharts-tooltip-cursor {
			display: none !important;
		}
	}
`;
